/* eslint-disable react/jsx-no-undef */
/* eslint-disable import/default */
/* eslint-disable import/namespace */
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState, lazy, Suspense } from "react";
import routes from "./routes";
import { checkAuthExpTime } from "../Utils/utils/CommanFnc";
import { logout, setUserData } from "../slices/AuthSlice";
//import { Loading } from "../components/Loading";
const HeaderNav = lazy( () => import("../components/admin/header-nav") )

export function Navigation(){
  const user = JSON.parse(localStorage.getItem("user"));
  //const permissions = user?.user?.permission
  const currentRoute = useLocation();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.authData.isLoggedIn)
  const [sideMenuOpen, setSideMenuOpen] = useState(false)
  //const [permission, setPermission] = useState([])
  //const permission = useSelector((state) => state.auth.authData?.user?.permission);
  const dispatch = useDispatch()
  useEffect( () =>{
    let menuCls = localStorage.getItem("GstartSideMenuOpen");
    if(menuCls === "true"){
      setSideMenuOpen(true)
    }
  },[])

  useEffect(()=>{
    const authData =  user ? { isLoggedIn: true, ...user } : { isLoggedIn: false, user: null }
    dispatch( setUserData(authData) )
  },[dispatch, user])

  useEffect(()=>{
    //dispatch(checkAuth())
    const isAuthTimeExp =  checkAuthExpTime()
    if(isAuthTimeExp){
      dispatch(logout())
    }
    if(!user && currentRoute.pathname !== "/"){
      navigate("/")
    }
  },[currentRoute.pathname, dispatch, navigate, user])

  // useEffect( () => {
  //   setPermission(permissions)
  // }, [permissions])

  let menu = (
    <React.Fragment>
      <Routes>
        <Route path="/" element={<routes.Login/>} />
      </Routes>
    </React.Fragment>
  );  
  if(isLoggedIn){
    menu = (
      <main>
        <section className="admin-dashboard">
          <div className="vertical-menu h-100">
            <Suspense fallback={<div>Loading...</div>}>
              <HeaderNav />
            </Suspense>
            <routes.SideNav />
            <div className="sidenav-overlay"></div>
            <div className="nav-shadow"></div>
            <div className={`main-container ${sideMenuOpen? "container-less":""}`}>
              <div className="main-container-wrap">  
                <div className="container-body">
                  <Routes>    
                    <Route path="/dashboard" element={<routes.Dashboard/>} /> 
                    <Route path="/change-password" element={<routes.ChangePass/>} /> 
                    <Route path="/roles" element ={<routes.RolesList/>} />
                    <Route path="/add-roles" element ={<routes.AddRoles/>} />
                    <Route path="/edit-role/:id" element ={<routes.AddRoles/>} />
                    <Route path="/manage-business" element={<routes.ManageBusiness/>} />
                    <Route path="/shopping-partners/:type" element={<routes.ListPartners/>}/>
                    <Route path="/add-shopping-partner/:type" element ={<routes.AddPartners/>}>
                        <Route path=":id" element ={<routes.AddPartners/>}/>    
                    </Route> 
                    <Route path="/users" element={<routes.UsersList/>}/>
                    <Route path="/user-add" element={<routes.AddUser/>}/>
                    <Route path="/edit-user/:id" element={<routes.AddUser/>}/>
                    <Route path="/products" element={ <routes.ProductsList/> } />
                    <Route path="/products/add" element={<routes.AddProducts/>}/>
                    <Route path="/products/edit/:id" element={<routes.AddProducts/>}/>``
                    <Route path="/my-attendances/" element={<routes.AttendancesList/>} />
                    <Route path="/team-attendances/" element={<routes.AttendancesList/>} />
                    <Route path="/all-attendances/" element={<routes.AttendancesList/>} />
                    <Route path="/beats" element={<routes.BeatList/>} />
                    <Route path="/add-beat" element={<routes.AddBeat/>} />
                    <Route path="/beat/edit/:id" element={<routes.AddBeat/>} />
                    <Route path="/team-leaves-request" element={<routes.LeaveRequestList/>}/>
                    <Route path="/my-leaves-request" element={<routes.LeaveRequestList/>}/>
                    <Route path="/all-leaves-request" element={<routes.LeaveRequestList/>}/>
                    <Route path="/orders" element={<routes.OrderList/>}/>
                    <Route path="/orders/create" element={<routes.CreateOrder/>}/>
                    <Route path="/orders/view/:id" element={<routes.ViewOrder/>}/>
                    <Route path="/orders/my-placed-orders" element={<routes.OrderList/>}/>
                    <Route path="/received-orders" element={<routes.OrderList/>}/>
                    <Route path="/scheme/create" element={<routes.CreateScheme/>} />
                    <Route path="/scheme" element={<routes.SchemeList/>} />
                    <Route path="/stocks" element={<routes.StockLsit/>}/>
                  </Routes> 
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    )
  }
  return (
    <div>
      {menu}
    </div>  
  )
}